var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomMedicalUmbrella = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.422 25.352V14.94h-.844v10.412c0 .778-.633 1.409-1.414 1.409-.782 0-1.415-.631-1.415-1.41a.42.42 0 0 0-.844 0 2.253 2.253 0 0 0 2.259 2.249 2.253 2.253 0 0 0 2.258-2.248z",
    fill: "#623424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.458 8.344v1.859h1.084V8.344a.42.42 0 0 1 .422-.42h1.867v-1.14h-1.867a.42.42 0 0 1-.422-.419V4.506h-1.084v1.86a.42.42 0 0 1-.422.419H12.11v1.14h1.927a.42.42 0 0 1 .422.419z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.443 12.828c.744-.697 1.657-1.065 2.64-1.065a3.772 3.772 0 0 1 2.649 1.073l.009.01c.257.27.474.573.648.902.173-.33.39-.633.648-.902l.018-.018c.743-.697 1.656-1.065 2.64-1.065a3.772 3.772 0 0 1 2.649 1.073l.009.01c.256.27.474.573.647.902a4.037 4.037 0 0 1 .666-.92c.744-.697 1.656-1.065 2.64-1.065a3.773 3.773 0 0 1 2.649 1.073l.008.01c.257.27.475.573.648.902.174-.33.392-.633.648-.902l.018-.018c.744-.697 1.657-1.065 2.64-1.065a3.77 3.77 0 0 1 2.649 1.073l.009.01.025.027a12.77 12.77 0 0 0-8.779-9.891A12.848 12.848 0 0 0 5.946 6.13 12.63 12.63 0 0 0 2.4 12.873l.025-.027.018-.018zm8.823-6.463a.42.42 0 0 1 .421-.42h1.928V4.087a.42.42 0 0 1 .421-.42h1.928a.42.42 0 0 1 .421.42v1.858h1.868a.42.42 0 0 1 .421.42v1.979a.42.42 0 0 1-.421.42h-1.868v1.859a.42.42 0 0 1-.421.42h-1.928a.42.42 0 0 1-.421-.42v-1.86h-1.928a.42.42 0 0 1-.421-.419V6.365z",
    fill: "#1E2969"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomMedicalUmbrella);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-medical-umbrella.636c8c22d1b47702767e63f74d51bb20.svg";